/* !
 * faq.js v1.0.0
 * Copyright, Connecty Inc.
 */

// Vue.jsカテゴリ選択アプリケーション
const CategorySelector = {
	data() {
		return {
			categories: [],
			faqList: [],
			filteredFaqs: [],
			displayCount: 10,
			selectedLarge: '',
			selectedMedium: '',
			selectedSmall: '',
			largeCategories: [],
			mediumCategories: [],
			smallCategories: [],
			isMediumDisabled: true,
			isSmallDisabled: true,
			canShowFaqs: false,
		};
	},
	mounted() {
		this.loadFaqList();
		this.easeScroll();
		this.easeScrollHash();
	},
	computed: {
		visibleFaqs() {
			return this.filteredFaqs.slice(0, this.displayCount);
		},
		hasMoreFaqs() {
			return this.filteredFaqs.length > this.displayCount;
		}
	},
	methods: {
		easeScroll() {
			if (this._easeScrollInitialized) {
				return;
			}
			this._easeScrollInitialized = true;
			const getHashFromHref = (href) => {
				if (!href || !/#/.test(href)) {
					return '';
				}
				return href.split('#')[1] || '';
			};
			const scrollToHash = (hash) => {
				const targetElement = hash === 'pagetop' ? null : document.getElementById(hash);
				if (hash !== 'pagetop' && !targetElement) {
					return false;
				}
				let pos = hash === 'pagetop' ? 0 : targetElement.getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				const spWidth = FUNCTIONS && FUNCTIONS.va && FUNCTIONS.va.device ? FUNCTIONS.va.device.sp : 768;
				const headerDesktop = FUNCTIONS && FUNCTIONS.va && FUNCTIONS.va.header ? FUNCTIONS.va.header.desktop : 100;
				const headerSp = FUNCTIONS && FUNCTIONS.va && FUNCTIONS.va.header ? FUNCTIONS.va.header.sp : 52;
				pos += offset;
				if (hash !== 'pagetop') {
					if (window.innerWidth < spWidth) {
						pos = pos - headerSp;
					} else {
						pos = pos - headerDesktop;
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
				return true;
			};
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const targetElement = document.getElementById(hash);
					if (!targetElement) {
						return;
					}
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						targetElement.querySelectorAll(focusableElementsSelector)
					);
					if (focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
				return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
						resolve(true);
					}, 100);
					addEventListener('scroll', function fn () {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			};
			document.addEventListener('click', async (e) => {
				const anchor = e.target.closest('a[rel="scroll"]');
				if (!anchor) {
					return;
				}
				const hash = getHashFromHref(anchor.href);
				if (!hash) {
					return;
				}
				e.preventDefault();
				const didScroll = scrollToHash(hash);
				if (!didScroll) {
					return;
				}
				await waitForScrollComplete(hash);
				return false;
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				const runHashScroll = async () => {
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const targetElement = document.getElementById(hash.replace('#', ''));
						if (!targetElement) {
							return;
						}
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						const focusableElements = Array.from(
							targetElement.querySelectorAll(focusableElementsSelector)
						);
						if (focusableElements.length) {
							focusableElements[0].focus();
						}
					}
				};
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
							resolve(true);
						}, 100);
						addEventListener('scroll', function fn () {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				};
					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';
					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';
						const targetId = hash.split('#')[1];
						const targetElement = document.getElementById(targetId);
						if (!targetElement) {
							return;
						}
						const spWidth = FUNCTIONS && FUNCTIONS.va && FUNCTIONS.va.device ? FUNCTIONS.va.device.sp : 768;
						const headerDesktop = FUNCTIONS && FUNCTIONS.va && FUNCTIONS.va.header ? FUNCTIONS.va.header.desktop : 100;
						const headerSp = FUNCTIONS && FUNCTIONS.va && FUNCTIONS.va.header ? FUNCTIONS.va.header.sp : 52;
						let pos = targetElement.getBoundingClientRect().top;
						if (window.innerWidth < spWidth) {
							pos -= headerSp;
						} else {
							pos -= headerDesktop;
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });
					}, 100);
					await waitForScrollComplete(hash);
				};
				if (document.readyState === 'complete') {
					runHashScroll();
				} else {
					window.addEventListener('load', runHashScroll, { once: true });
				}
			}
		},
		async loadFaqList() {
			try {
				const response = await fetch('/cnt_common/data/faq/faq_list.csv');
				const csvText = await response.text();
				this.parseFaqList(csvText);
			} catch (error) {
				console.error('FAQ CSVファイルの読み込みエラー:', error);
			}
		},
		
		parseFaqList(csvText) {
			const lines = csvText.trim().split('\n');
			this.categories = [];
			this.faqList = [];
			
			for (let i = 1; i < lines.length; i++) {
				const line = lines[i];
				const values = this.parseCSVLine(line);
				if (values.length >= 5) {
					// カテゴリ情報を収集
					this.categories.push({
						category1: values[0].trim(),
						category2: values[1].trim(),
						category3: values[2].trim()
					});
					
					// FAQ情報を保存
					this.faqList.push({
						id: i,
						category1: values[0].trim(),
						category2: values[1].trim(),
						category3: values[2].trim(),
						question: values[3].trim(),
						answer: values[4].trim()
					});
				}
			}
			
			// 大カテゴリ一覧を作成
			this.largeCategories = [...new Set(this.categories.map(item => item.category1))];
			this.filteredFaqs = [];

			// URLパラメータチェック
			this.checkUrlParams();
		},

		checkUrlParams() {
			const params = new URLSearchParams(window.location.search);
			const cat1 = params.get('category1');
			const cat2 = params.get('category2');
			const cat3 = params.get('category3');
			if (!cat1) return;

			// category1: 大カテゴリを番号で選択
			const cat1Index = parseInt(cat1, 10) - 1;
			if (isNaN(cat1Index) || cat1Index < 0 || cat1Index >= this.largeCategories.length) return;
			this.selectedLarge = this.largeCategories[cat1Index];
			this.onLargeChange();

			// category2: 中カテゴリを番号で選択
			if (cat2 && this.mediumCategories.length > 0) {
				const cat2Index = parseInt(cat2, 10) - 1;
				if (!isNaN(cat2Index) && cat2Index >= 0 && cat2Index < this.mediumCategories.length) {
					this.selectedMedium = this.mediumCategories[cat2Index];
					this.onMediumChange();

					// category3: 小カテゴリを番号で選択
					if (cat3 && this.smallCategories.length > 0) {
						const cat3Index = parseInt(cat3, 10) - 1;
						if (!isNaN(cat3Index) && cat3Index >= 0 && cat3Index < this.smallCategories.length) {
							this.selectedSmall = this.smallCategories[cat3Index];
							this.onSmallChange();
						}
					}
				}
			}

			this.canShowFaqs = this.shouldShowFaqs();
		},

		shouldShowFaqs() {
			if (!this.selectedLarge || !this.selectedMedium) return false;

			// 小カテゴリが存在しない場合は中カテゴリ選択時点で表示
			if (this.smallCategories.length === 0) return true;

			// 小カテゴリが存在する場合は小カテゴリ選択時のみ表示
			return !!this.selectedSmall;
		},
		
		parseCSVLine(line) {
			const result = [];
			let current = '';
			let inQuotes = false;
			
			for (let i = 0; i < line.length; i++) {
				const char = line[i];
				
				if (char === '"') {
					if (inQuotes && line[i + 1] === '"') {
						current += '"';
						i++;
					} else {
						inQuotes = !inQuotes;
					}
				} else if (char === ',' && !inQuotes) {
					result.push(current);
					current = '';
				} else {
					current += char;
				}
			}
			
			result.push(current);
			return result;
		},
		
		onLargeChange() {
			this.selectedMedium = '';
			this.selectedSmall = '';
			this.smallCategories = [];
			this.isSmallDisabled = true;
			this.displayCount = 10;
			this.canShowFaqs = false;
			
			if (this.selectedLarge) {
				const filtered = this.categories.filter(item => item.category1 === this.selectedLarge);
				this.mediumCategories = [...new Set(filtered.map(item => item.category2))].filter(v => v !== '');
				
				// FAQ表示
				if (this.mediumCategories.length === 0) {
					this.isMediumDisabled = true;
				} else {
					this.isMediumDisabled = false;
				}
			} else {
				this.mediumCategories = [];
				this.isMediumDisabled = true;
				this.canShowFaqs = false;
			}
			
			this.filterFaqs();
		},
		
		onMediumChange() {
			this.selectedSmall = '';
			this.displayCount = 10;
			this.canShowFaqs = false;
			
			if (this.selectedMedium) {
				const filtered = this.categories.filter(item => 
					item.category1 === this.selectedLarge && item.category2 === this.selectedMedium
				);
				this.smallCategories = [...new Set(filtered.map(item => item.category3))].filter(v => v !== '');
				
				// FAQ表示
				if (this.smallCategories.length === 0) {
					this.isSmallDisabled = true;
				} else {
					this.isSmallDisabled = false;
				}
			} else {
				this.smallCategories = [];
				this.isSmallDisabled = true;
			}

			this.canShowFaqs = this.shouldShowFaqs();
			
			this.filterFaqs();
		},
		
		onSmallChange() {
			this.displayCount = 10;
			this.canShowFaqs = this.shouldShowFaqs();
			this.filterFaqs();
		},
		
		loadMore() {
			this.displayCount += 10;
			this.$nextTick(() => {
				this.initAccordion();
			});
		},
		
		filterFaqs() {
			if (!this.shouldShowFaqs()) {
				this.filteredFaqs = [];
				this.canShowFaqs = false;
				return;
			}
			
			this.filteredFaqs = this.faqList.filter(faq => {
				if (this.smallCategories.length === 0) {
					return faq.category1 === this.selectedLarge &&
						faq.category2 === this.selectedMedium;
				}

				if (this.selectedSmall) {
					return faq.category1 === this.selectedLarge && 
						faq.category2 === this.selectedMedium && 
						faq.category3 === this.selectedSmall;
				}
				return false;
			});

			this.canShowFaqs = true;

			this.$nextTick(() => {
				this.initAccordion();
			});
		},

		initAccordion() {
			const details = document.querySelectorAll('.mod-faqList .js-accordion');
			details.forEach(ele => {
				// 既にイベント設定済みならスキップ
				if (ele.dataset.accordionInit) return;
				ele.dataset.accordionInit = 'true';

				const summary = ele.querySelector('summary');
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const plus = ele.querySelector('.mod-accordion-plus');
				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['90deg', '0deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
						close.onfinish = () => {
							ele.removeAttribute('open');
						}
					} else {
						ele.setAttribute('open', 'true');
						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['0deg', '90deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
				});
			});
		},
		
		resetCategories() {
			this.selectedLarge = '';
			this.selectedMedium = '';
			this.selectedSmall = '';
			this.mediumCategories = [];
			this.smallCategories = [];
			this.isMediumDisabled = true;
			this.isSmallDisabled = true;
			this.canShowFaqs = false;
			this.filteredFaqs = [];
			this.displayCount = 10;

			// URLパラメータをクリア
			const url = new URL(window.location);
			url.search = '';
			window.history.replaceState({}, '', url);
		}
	}
};

((FUNCTIONS) => {

	// Vue.js初期化
	const initCategorySelector = () => {
		if (typeof Vue !== 'undefined' && Vue.createApp) {
			const element = document.getElementById('categoryApp');
			if (element) {
				Vue.createApp(CategorySelector).mount('#categoryApp');
			}
		}
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const faqFUNCTIONS = () => {
		initCategorySelector();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { faqFUNCTIONS(); }) : faqFUNCTIONS();

})(window.FUNCTIONS);
